var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/multiply/RemoveNodeDialog.tsx";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import * as React from 'react';
import { Button, Toolbar, IconButton, List, ListItem } from '@mui/material';
import styled from 'styled-components';
import { Close } from '@mui/icons-material';
import { DialogContent as DialogContentInit } from '@gmini/ui-kit/lib/DialogContent';
import { DialogActions } from '@gmini/ui-kit/lib/DialogActions';
import { Dialog } from '@gmini/ui-kit/lib/Dialog';
import { DialogTitle } from '@gmini/ui-kit/lib/DialogTitle';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { Box } from '@gmini/ui-kit/lib/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RemoveNodeDialog = /*#__PURE__*/React.memo(function (_ref) {
  var onClose = _ref.onClose,
      removeDependency = _ref.removeDependency,
      open = _ref.open,
      name = _ref.name;
  return /*#__PURE__*/_jsxs(Dialog, {
    open: open,
    maxWidth: "sm",
    fullWidth: true,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      children: /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(Toolbar, {
          disableGutters: true,
          variant: "dense",
          children: [/*#__PURE__*/_jsx(Box, {
            flexGrow: 1,
            children: " \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0430\u043F\u043A\u0443"
          }), /*#__PURE__*/_jsx(IconButton, {
            onClick: onClose,
            size: "large",
            children: /*#__PURE__*/_jsx(Close, {
              fontSize: "small"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(DialogContent, {
      dividers: true,
      children: [/*#__PURE__*/_jsx(QuestionText, {
        color: "textSecondary",
        children: "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C ?"
      }), /*#__PURE__*/_jsx(Box, {
        display: "flex",
        flexDirection: "column",
        children: name === null || name === void 0 ? void 0 : name.map(function (name, i) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _jsx(List, {
              dense: true,
              children: /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "button",
                  children: name
                })
              })
            }, i)
          );
        })
      }), /*#__PURE__*/_jsx(StatusPanelLayout, {
        children: /*#__PURE__*/_jsx(DependencyName, {
          align: "inherit"
        })
      }), /*#__PURE__*/_jsx(Typography, {
        color: "error",
        variant: "caption",
        children: "\u0411\u0443\u0434\u0443\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0432\u0441\u0435 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B/\u043F\u0430\u043F\u043A\u0438"
      })]
    }), /*#__PURE__*/_jsxs(DialogActions, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "cancel",
        variant: "contained",
        onClick: onClose,
        children: "\u041E\u0442\u043C\u0435\u043D\u0430"
      }), /*#__PURE__*/_jsx(DangerButton, {
        "data-test-id": "confirm",
        onClick: removeDependency,
        variant: "contained",
        autoFocus: true,
        children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
      })]
    })]
  });
});
RemoveNodeDialog.displayName = 'RemoveNodeDialog';
export var StatusPanelLayout = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px'
});
export var DangerButton = styled(Button)({
  color: '#fff',
  backgroundColor: '#f44336',
  '&:hover': {
    backgroundColor: '#d32f2f'
  }
});
var DependencyName = styled(Typography)({
  fontSize: '18px',
  color: '#1B2B4B'
});
var QuestionText = styled('div')({
  fontSize: '14px',
  marginBottom: '20px'
});
var DialogContent = styled(DialogContentInit)({
  padding: '36px 24px'
});